<h2 class="sr-only">{{ "Standardsuche" | translate }}</h2>

@if (standard && standard.mHasRightMassenabfrage?.access != "NONE") {
  <form (ngSubmit)="onSubmit()" [meta]="standard" #form="ngForm">
    <div class="row mb-0">
      <cap-tagebuch-nummer
        (ngModelChange)="standard && (standard.tagebuchnummer = $event)"
        [hasfocus]="true"
        [ngModel]="standard && standard.tagebuchnummer"
        class="col-md-12"
        heading="Grundbuchgeschäft"
        id="grundbuchamtId"
        name="grundbuchamtId"></cap-tagebuch-nummer>
    </div>
    <div class="row my-2">
      <div class="col-3">
        <cap-tagebuchstatus-selection
          (ngModelChange)="standard && (standard.status = $event)"
          [ngModel]="standard && standard.status"
          name="bearbeitetstatusSelection"></cap-tagebuchstatus-selection>
      </div>
    </div>
    <cap-grundstueck-nummer
      (ngModelChange)="standard && (standard.grundstueckNummer = $event)"
      [ngModel]="standard && standard.grundstueckNummer"
      [nurGueltige]="false"
      [searchMode]="gbGemeindeSearchMode"
      heading="BeteiligteGrundstuecke"
      name="grundstueckNummer"></cap-grundstueck-nummer>
    <cap-form-row>
      <cap-form-control column-classes="col-md-1,col-md-3" invalidKey="EingabeMussValideEgridSein" labelKey="EGRID">
        <input
          (change)="standard.egrid.value = trim($event.target.value)"
          (ngModelChange)="standard && standard.egrid && (standard.egrid.value = $event)"
          [ngModel]="standard && standard.egrid && standard.egrid.value"
          name="egrid.value"
          type="text" />
      </cap-form-control>
    </cap-form-row>
    <div class="p-2" id="actionpane">
      <div class="rechtsbuendig">
        <button (click)="onReset()" class="btn btn-outline-primary btn-actionpane" type="button">{{ "Zurücksetzen" | translate }}</button>
        <button [disabled]="!form.form.valid" class="btn btn-primary btn-actionpane" type="submit">{{ "Suche" | translate }}</button>
      </div>
    </div>
  </form>
}

@if (standard && standard.mHasRightMassenabfrage?.access === "NONE") {
  <form (ngSubmit)="onSubmit()" [doValidate]="true" [meta]="standard" #form="ngForm" capEgridValidator>
    <cap-form-row class="mb-0">
      <cap-tagebuch-nummer
        (ngModelChange)="standard && (standard.tagebuchnummer = $event)"
        [hasfocus]="true"
        [hasRightMassenabfrage]="false"
        [ngModel]="standard && standard.tagebuchnummer"
        class="col-md-12"
        heading="Grundbuchgeschäft"
        id="grundbuchamtId"
        name="grundbuchamtId"></cap-tagebuch-nummer>
    </cap-form-row>
    <div class="row my-2">
      <div class="col-3">
        <cap-tagebuchstatus-selection
          (ngModelChange)="standard && (standard.status = $event)"
          [ngModel]="standard && standard.status"
          name="bearbeitetstatusSelection"></cap-tagebuchstatus-selection>
      </div>
    </div>
    <cap-grundstueck-nummer
      (ngModelChange)="standard && (standard.grundstueckNummer = $event)"
      [ngModel]="standard && standard.grundstueckNummer"
      [nurGueltige]="false"
      [searchMode]="gbGemeindeSearchMode"
      heading="BeteiligteGrundstuecke"
      name="grundstueckNummer"></cap-grundstueck-nummer>
    <cap-form-row>
      <cap-form-control column-classes="col-md-1,col-md-3" invalidKey="EingabeMussValideEgridSein" labelKey="EGRID">
        <input
          (change)="standard.egrid.value = trim($event.target.value)"
          (ngModelChange)="standard && standard.egrid && (standard.egrid.value = $event)"
          [ngModel]="standard && standard.egrid && standard.egrid.value"
          name="egrid.value"
          type="text" />
      </cap-form-control>
    </cap-form-row>
    <div class="p-2" id="actionpane">
      <div class="rechtsbuendig">
        <button (click)="onReset()" class="btn btn-outline-primary btn-actionpane" type="button">{{ "Zurücksetzen" | translate }}</button>
        <button [disabled]="!form.form.valid" class="btn btn-primary btn-actionpane" type="submit">{{ "Suche" | translate }}</button>
      </div>
    </div>
  </form>
}
